import React from 'react'
import './claims.scss'
import { Container } from 'react-bootstrap';
import { MainHeading, Breadcrumb, FeaturedBar, FindAgent, NewsCard, Faq, ReportClaims, ClaimsResources} from '../../components';
const Claims = () => {
    // breadcrumbs list
    const breadcrumbs = [
        { label: "Sentry Insurance home", link: "/" },
        { label: "Claims services", link: "/claims" },
    ];
 
    //cliams status data
    const StatusCardData = [
        {
          id: 1,
          title: 'Review claim status',
          description:
            'Check the status of a claim already in progress. You’ll need to know the claim number and the date of the incident.',
          linkUrl: '',
          linkText: 'View claims >',
        },
        {
          id: 2,
          title: 'Review claim payments',
          description:
            'Check on payments related to a claim. You’ll need to know the claim number and your federal employer identification number (FEIN).',
          linkUrl: '/',
          linkText: 'View payments >',
        },
    ];

    //LoginCardData
    const LoginData = [
        {
            id: 1,
            title: "Sentry customers can report, track, and monitor claims—all from our online portal.",
            link: "",
            btnText: "Log in",
        },
    ];

    //faq data
    const FaqData = [
        {
          id: 1,
          eventKey: "0",
          header: "What are your giving criteria?",
          body: "We focus our giving efforts on education, workforce development, and local organizations working to improve quality of life and build stronger, more equitable communities where Sentry employees live and work. We don’t give to individuals, political or lobbying organizations, or third-party fundraisers."
        },
        {
          id: 2,
          eventKey: "1",
          header: "Where do you give geographically?",
          body: "We give where our associates live and work. This includes Stevens Point, where Sentry is headquartered, the island of Maui—our home away from home—and the communities where our field offices are located."
        },
        {
            id: 3,
            eventKey: "2",
            header: "Who should I contact for more information?",
            body: "Kalynn Pempek is the Sentry Insurance Foundation Executive Director and can be reached via email at kalynn.pempek@sentry.com or by phone at 715-346-7636."
        }
    ];

    // find agent options
    const Selectoptions = [
        { value: 'Constructions', label: 'Constructions' },
        { value: 'DealerShip', label: 'DealerShip' },
        { value: 'Manufacturing and process industries', label: 'Manufacturing and process industries' },
        { value: 'Retailers and Distributors', label: 'Retailers and Distributors' },
        { value: 'Service industries', label: 'Service industries' },
        { value: 'Trucking', label: 'Trucking' },
    ];
    

    return (
        <>
            <div className='claims-main'>
                <Container>
                    {/* Breadcrumb */}
                    <Breadcrumb crumbs={breadcrumbs} />

                    {/* heading  */}
                    <MainHeading title="Claims services" showshare={false} />

                    {/* report claims*/}
                    <ReportClaims/>

                    {/* status claims */}
                    <NewsCard Title="" CardData={StatusCardData} showNavLink={false} subTitle=" " />

                    {/* claim resources */}
                    <ClaimsResources/>

                    {/* llogin Card */}
                    <FeaturedBar data={LoginData} />

                    {/* Faq */}
                    <Faq FaqData={FaqData} heading={'FAQs'}/>

                    {/* find agent */}
                    <FindAgent options={Selectoptions} />
                </Container>
            </div>
        </>
    )
}

export default Claims